import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/es';
export const locale = {
  lang: 'es',
  data: {
    'GENERICSURVEY': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
      },
      'TITULO': 'Reporte encuesta generica',
      'SUBTITULO': 'Consulte el reporte de la encuesta generica ingresando el token:',
      'CAMPOS': {
        'Token': 'Token:',
      },
      'RESULTADOS': {
        'CARGANDO': 'Cargando resultados de la búsqueda',
        'TITULO': 'Resultados',
        'ENCONTRADAS': 'Total de usuarios encontrados',
        'DESCARGAR': 'Descargar información en formato Excel',
        'SINRESULTADOS': 'No se encontraron usuarios para el token especificado'
      }
    }
  }
};
